import IsMatchTitleCheckbox from "./IsMatchTitleCheckbox"

export interface Props {
  checked: boolean
  isDisabled: boolean
  onChange: () => void
}

export interface ComponentProps extends Props {}

export default IsMatchTitleCheckbox
